//ADD 4.1 utility for set
export async function prepareEncryptedHeader(value: string, password: string) {
	const salt = crypto.getRandomValues(new Uint8Array(16)) // salt random 16 byte
	const iv = crypto.getRandomValues(new Uint8Array(12)) // iv random 12 byte (AES-GCM)

	// Genera la chiave AES da password + salt
	const key = await generateKeyFromPassword(password, salt)

	// Cifra il valore
	const encrypted = await encryptAES256GCM(value, key, iv)

	// Per inviarlo come header, conviene mandare anche salt e iv (encoded)
	const saltB64 = arrayBufferToBase64(salt.buffer)
	const ivB64 = arrayBufferToBase64(iv.buffer)

	// Puoi creare un header unico con tutte info separate da punto o altro
	const headerValue = `${saltB64}.${ivB64}.${encrypted}`

	return headerValue
}

// Converti stringa in ArrayBuffer
function strToArrayBuffer(str: string): ArrayBuffer {
	return new TextEncoder().encode(str)
}

// Converti ArrayBuffer in base64
function arrayBufferToBase64(buffer: ArrayBuffer): string {
	const bytes = new Uint8Array(buffer)
	let binary = ''
	for (let i = 0; i < bytes.byteLength; i++) {
		binary += String.fromCharCode(bytes[i])
	}
	return btoa(binary)
}

// Cifra con AES-256-GCM
async function encryptAES256GCM(
	plaintext: string,
	key: CryptoKey,
	iv: Uint8Array
): Promise<string> {
	const encoded = strToArrayBuffer(plaintext)
	const ciphertext = await crypto.subtle.encrypt(
		{
			name: 'AES-GCM',
			iv, // vettore di inizializzazione, 12 byte raccomandati
		},
		key,
		encoded
	)
	return arrayBufferToBase64(ciphertext)
}

// Genera una chiave AES-256-GCM da password (usando PBKDF2)
async function generateKeyFromPassword(
	password: string,
	salt: Uint8Array
): Promise<CryptoKey> {
	const pwUtf8 = new TextEncoder().encode(password)
	const baseKey = await crypto.subtle.importKey(
		'raw',
		pwUtf8,
		'PBKDF2',
		false,
		['deriveKey']
	)
	const key = await crypto.subtle.deriveKey(
		{
			name: 'PBKDF2',
			salt,
			iterations: 100000,
			hash: 'SHA-256',
		},
		baseKey,
		{ name: 'AES-GCM', length: 256 },
		true,
		['encrypt', 'decrypt']
	)
	return key
}
